// src/stone/icons/MobileBanking.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MobileBanking = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M3.5 18.5h17v2h-17z" }),
      /* @__PURE__ */ jsx("path", { d: "M6.5 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM4.379.879A3 3 0 0 1 6.5 0h11a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3V3A3 3 0 0 1 4.379.879" }),
      /* @__PURE__ */ jsx("path", { d: "M13 3.5V18h-2V3.5z" }),
      /* @__PURE__ */ jsx("path", { d: "M11.362 5.052c1.491-.106 3.2.27 4.12.777l.876.481-.963 1.753-.876-.482c-.536-.294-1.85-.617-3.015-.534-.574.041-.987.174-1.23.346-.19.133-.316.31-.316.671 0 .458.17.723.5.965.4.293.974.505 1.728.756l.162.054c.65.215 1.441.477 2.065.88.748.481 1.368 1.236 1.368 2.393 0 .965-.323 1.774-.945 2.361-.595.563-1.37.835-2.127.948-1.498.225-3.277-.117-4.674-.622l-.94-.34.68-1.88.94.339c1.224.442 2.649.683 3.698.525.517-.077.852-.237 1.05-.423.17-.16.319-.417.319-.908 0-.3-.108-.49-.452-.713-.402-.259-.961-.445-1.704-.692l-.073-.025c-.702-.234-1.584-.531-2.277-1.04-.76-.558-1.319-1.385-1.319-2.578 0-1.018.448-1.801 1.164-2.306.662-.467 1.486-.652 2.24-.706" })
    ]
  }
);
var MobileBanking_default = MobileBanking;

export {
  MobileBanking_default
};
